import { parse as n } from "../../../../cookie@0.5.0/node_modules/cookie/index.js";
function i() {
  return typeof document == "object" && typeof document.cookie == "string";
}
function c(t) {
  return typeof t == "string" ? n(t) : typeof t == "object" && t !== null ? t : {};
}
function p(t, e = {}) {
  const r = o(t);
  if (!e.doNotParse)
    try {
      return JSON.parse(r);
    } catch {
    }
  return t;
}
function o(t) {
  return t && t[0] === "j" && t[1] === ":" ? t.substr(2) : t;
}
export {
  i as hasDocumentCookie,
  c as parseCookies,
  p as readCookie
};
